export default __webpack_public_path__ + "static/compareItemImg2-63a9ef6f71f54ed832b227c3044cdc63.png";